import React, { Component } from "react";
import "../../App.css";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import ViewTopBar from "../common_components/viewChanger";
import BottomBar from "../common_components/bottom_bar.component";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { Fade } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import { Redirect } from "react-router-dom";
import logo from "../../assets/img/cw_logo.png";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  image: {
    "@media (min-width:200px)": {
      marginTop: -15,
    },
    "@media (min-width:600px)": {
      marginTop: -15,
    },
    "@media only screen and (max-width: 960px) and (min-width:601px)": {
      height: 700,
      width: "auto",
      marginTop: -10,
    },
    "@media only screen and (max-width: 1260px) and (min-width: 960px)": {
      height: 750,
      width: "auto",
      marginTop: -10,
    },
    "@media only screen and (max-width: 1960px) and (min-width: 1260px)": {
      height: "auto",
      marginTop: -10,
    },
  },
  text_title: {
    fontFamily: "Open Sans",
    fontWeight: "600",
    fontSize: 32,
    marginBottom: "5%",
  },
  text_grid: {
    width: 930,
    marginLeft: 150,
    marginRight: 150,
    fontSize: "1.25rem",
    "@media (min-width:200px)": {
      marginLeft: 50,
      marginRight: 50,
      width: 450,
    },
    "@media (min-width:600px)": {
      marginLeft: 80,
      marginRight: 80,
      width: 450,
    },
    "@media only screen and (max-width: 960px) and (min-width:601px)": {
      marginLeft: 100,
      marginRight: 100,
      width: 400,
    },
    "@media only screen and (max-width: 1600px) and (min-width: 1265px)": {
      width: 440,
    },
    "@media only screen and (max-width: 1760px) and (min-width: 1600px)": {
      width: 670,
    },
    "@media only screen and (max-width: 1960px) and (min-width: 1760px)": {
      width: 800,
    },
  },
  splash_text: {
    fontSize: "3rem",
    fontFamily: "Open Sans",
    fontWeight: "200",
    textAlign: "center",
    "@media (min-width:200px)": {
      fontSize: "1rem",
    },
    "@media (min-width:600px)": {
      fontSize: "1.5rem",
    },
    "@media (min-width:960px)": {
      fontSize: "2rem",
    },
  },
  text: {
    color: "black",
    fontFamily: "Open Sans",
    fontWeight: "300",
    fontSize: "18px",
    width: "90%",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#FFF",
    width: 210,
    borderColor: "#F6277F",
    borderWidth: 40,
  },
  enter_text: {
    color: "#FFF",
    fontWeight: "600",
    fontFamily: "Open Sans",
    fontSize: 24,
    textTransform: "none",
  },
  progress_color: {
    color: "#FFF",
  },
  notchedOutline: {
    borderWidth: "1px",
  },
  focused: {
    borderColor: "yellow",
  },
});

const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "green",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#000",
      },
      "&:hover fieldset": {
        borderColor: "#ff57a0",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#ff57a0",
      },
    },
  },
})(TextField);

class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      email_err: "",
      number: "",
      message: "",
      loading: false,
      thank_screen: false,
      redirect: false,
    };
  }

  componentDidMount() {
    document.title = "About | CanaWho";
  }

  submitForm() {
    const { name, email, number, message } = this.state;
    // console.log(name, email, number, message);
    if (name && email && message) {
      axios
        .post("https://backend.canawho.com/notification/sendContact", {
          name: name,
          email: email,
          phone: number,
          message: message,
        })
        .then((product_response) => {
          // console.log("BRAND IS: ", product_response);
          this.setState({ name: "", email: "", number: "", message: "" });
          this.setState({ thank_screen: true });
          // alert(
          //   "Your request to contact has been sent successfully! Have a great day!"
          // );
        })
        .catch((err) => {
          // console.log(err);
          // console.log(err.response);
          alert("Unexpected Error");
        });
    } else {
      alert("Please fill in all the details");
    }
  }

  handleRedirect() {
    setTimeout(() => {
      if (this.state.thank_screen) {
        // this.setState({ thank_screen: false });
      }
    }, 5000);
  }

  render() {
    const { classes } = this.props;
    const {
      name,
      email,
      email_err,
      number,
      message,
      loading,
      redirect,
      thank_screen,
    } = this.state;

    if (thank_screen === true) {
      this.handleRedirect();
      return (
        <div className={classes.root}>
          <ViewTopBar />
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
            style={{ minHeight: "100vh" }}
          >
            <h3 className={classes.splash_text}>
              Thank you for contacting CanaWho, our team will get back to you
              shortly.
            </h3>
            <h1
              className={classes.text_title}
              style={{ fontWeight: "bold", marginTop: -5 }}
            >
              <u>Express Yourself !</u>
            </h1>
          </Grid>
          <Grid container alignItems="center" justify="center">
            <img
              alt=""
              style={{ padding: 30, height: 60, boxSizing: "unset" }}
              src={logo}
            />
          </Grid>
        </div>
      );
    } else {
      return (
        <div className={classes.root}>
          <ViewTopBar />
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            style={{ minHeight: "80vh", width: "100%", marginTop: "30px" }}
          >
            <h1 class={classes.text_title}>
              <u>Contact CanaWho</u>
            </h1>
            <Grid container alignItems="center" justify="center">
              <Grid item container xs={10} alignItems="center" justify="center">
                <CssTextField
                  style={{ width: "100%" }}
                  variant="outlined"
                  margin="normal"
                  required
                  id="first_name"
                  label="Name"
                  //name="first_name"
                  type="text"
                  value={name}
                  onChange={(text) => {
                    this.setState({
                      name: text.target.value,
                      fname_err: false,
                    });
                  }}
                  autoComplete="section-name"
                  autoFocus
                  InputLabelProps={{ style: { color: "grey" } }}
                />
                <CssTextField
                  error={email_err}
                  helperText={email_err ? "Please enter a valid email" : null}
                  style={{ width: "100%" }}
                  variant="outlined"
                  margin="normal"
                  required
                  label="Email"
                  type="text"
                  id="email"
                  value={email}
                  onChange={(text) => {
                    this.setState({
                      email: text.target.value,
                      lname_err: false,
                    });
                  }}
                  InputLabelProps={{ style: { color: "grey" } }}
                />
                <CssTextField
                  style={{ width: "100%" }}
                  variant="outlined"
                  margin="normal"
                  //name="last_name"
                  label="Phone Number"
                  type="text"
                  id="phone_number"
                  value={number}
                  onChange={(text) => {
                    this.setState({
                      number: text.target.value,
                      lname_err: false,
                    });
                  }}
                  InputLabelProps={{ style: { color: "grey" } }}
                />
                <CssTextField
                  style={{ width: "100%" }}
                  variant="outlined"
                  margin="normal"
                  required
                  label="Message"
                  type="text"
                  id="message"
                  multiline
                  value={message}
                  rows={10}
                  onChange={(text) => {
                    this.setState({
                      message: text.target.value,
                      lname_err: false,
                    });
                  }}
                  InputLabelProps={{ style: { color: "grey" } }}
                />
                <Button
                  // type="submit"
                  fullWidth
                  variant="contained"
                  style={{
                    backgroundColor: "#F6277F",
                    width: "100%",
                    marginTop: "100px",
                  }}
                  className={classes.submit}
                  onClick={() => this.submitForm()}
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress
                      className={classes.progress_color}
                      size={25}
                    />
                  ) : (
                    <Typography variant="h7" className={classes.enter_text}>
                      Submit
                    </Typography>
                  )}
                </Button>
              </Grid>
              <Grid
                item
                xs={12}
                alignItems="center"
                justify="center"
                style={{ paddingLeft: "10%" }}
              >
                <Typography variant="h5" class={classes.text}>
                  CanaWho™ Inc was founded in Toronto with the intention of
                  uniting the cannabis space.
                  <br />
                  <br />
                  We would love to hear from you, feel free to contact us with
                  any questions and we will get back to you as soon as possible.
                  <br />
                  <br />
                  <br />
                  CanaWho™ Inc
                  <br />
                  2238 Dundas Street W<br />
                  PO BOX 59047
                  <br />
                  Toronto, Ontario
                  <br />
                  M6R 3B5
                  <br />
                  <br />
                  info@canawho.com
                </Typography>
              </Grid>
              <Grid item xs={4}></Grid>
            </Grid>
          </Grid>
          <Grid style={{ marginTop: "5%" }}>
            <BottomBar />
          </Grid>
        </div>
      );
    }
  }
}

ContactUs.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ContactUs);
